import axios from "axios";
import Cookie from "./utils/cookie.util.js";
import toasty from "./utils/toasty.util.jsx";
import { getIframeToken, setIframeToken, clearIframeToken } from "./utils/iframeAuth.util.js";


axios.defaults.baseURL = import.meta.env.APP_BASE_URL;


axios.defaults.headers['Content-Type'] = 'application/json'
axios.interceptors.request.use(async (request) => {
   const token = await Cookie.get('x-token') || getIframeToken();
   if (token) {
       axios.defaults.headers['x-client-route'] = window.location.pathname;
       request.headers.Authorization = token;
   }
   return request
});


axios.interceptors.response.use(async (response) => {


   const token = response.headers['x-token'];
   if (token) {
       await Cookie.set('x-token', token);
       setIframeToken(token);
   }


   return response;
}, async (error) => {
   if (error?.response?.status == 401 && error?.response?.data?.status === 'TERMINATE') {
       toasty.error(error.response.data.message);
       await Cookie.clearAll();
       clearIframeToken();
       window.location.href = '/login';
   }
   return Promise.reject(error);
});
